import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  Stack,
  Typography,
} from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import StarIcon from "@mui/icons-material/Star";

const FeatureComingSoonDialog = ({
  open,
  onClose,
  featureName = "VIN Search",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="feature-coming-soon-title"
      aria-describedby="feature-coming-soon-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="feature-coming-soon-title"
        sx={{
          textAlign: "center",
          pb: 0,
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{ justifyContent: "center", mb: 1 }}
        >
          <BuildIcon
            color="primary"
            sx={{
              fontSize: 48,
              animation: "wrench-spin 3s linear infinite",
            }}
          />
          <StarIcon
            color="secondary"
            sx={{
              fontSize: 48,
              animation: "sparkle-glow 2s ease-in-out infinite",
            }}
          />
        </Stack>
        <Typography variant="h5" component="div" sx={{ fontWeight: 600 }}>
          {featureName} is Under Development
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, textAlign: "center" }}>
        <DialogContentText id="feature-coming-soon-description">
          <Typography variant="body1" paragraph sx={{ color: "text.primary" }}>
            Thank you for your interest in this feature! We're actively
            implementing
            {featureName} and it will be available soon.
          </Typography>
          <Typography
            variant="body2"
            paragraph
            sx={{ color: "text.secondary" }}
          >
            Our development team is working hard to deliver an exceptional
            experience with enhanced functionality and improved performance.
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "primary.main", fontWeight: 500 }}
          >
            In the meantime, you can explore our other available features:
          </Typography>
        </DialogContentText>

        <Box sx={{ mt: 2, p: 2, bgcolor: "action.hover", borderRadius: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
            Available Features:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: 13 }}>
            • Pricelist Search
          </Typography>
          <Typography variant="body2" sx={{ fontSize: 13 }}>
            • Analytics & Insights
          </Typography>
          <Typography variant="body2" sx={{ fontSize: 13 }}>
            • Invoice Management
          </Typography>
          <Typography variant="body2" sx={{ fontSize: 13 }}>
            • Part Details Lookup
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pt: 1, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          size="medium"
          sx={{
            px: 4,
            py: 1,
            borderRadius: 2,
            fontWeight: 600,
          }}
        >
          Back to Search
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeatureComingSoonDialog;
